import { Phone } from "lucide-react";

export const FloatingCTA = () => {
  return (
    <>
      {/* Desktop floating button - positioned bottom right */}
      <a
        href="tel:0668032561"
        className="hidden md:flex fixed bottom-8 right-8 z-[9999] items-center gap-3 bg-yellow-400 hover:bg-yellow-500 text-black font-bold uppercase tracking-wide px-6 py-4 rounded-sm shadow-[0_0_30px_rgba(250,204,21,0.5)] transition-all duration-300 hover:scale-105 animate-pulse-glow"
        data-testid="floating-cta-desktop"
      >
        <Phone className="w-5 h-5" />
        <span>Appeler maintenant</span>
      </a>

      {/* Mobile sticky bottom bar - FIXED at bottom, full width */}
      <div 
        className="md:hidden fixed bottom-0 left-0 right-0 z-[9999] bg-yellow-400 shadow-[0_-4px_20px_rgba(0,0,0,0.3)]" 
        data-testid="floating-cta-mobile"
        style={{ position: 'fixed', bottom: 0 }}
      >
        <a
          href="tel:0668032561"
          className="flex items-center justify-center gap-3 py-4 text-black font-bold uppercase tracking-wide text-base"
        >
          <Phone className="w-5 h-5" />
          <span>Appeler – 06 68 03 25 61</span>
        </a>
      </div>
    </>
  );
};

export default FloatingCTA;
